import { defineComponent } from 'vue';
import { PageVue } from '@/staff/primary/club-layout/page';
import { useI18n } from 'vue-i18n';
import { ProgramsTableVue } from '@/staff/primary/program/programs-table';
import { FairplayerButtonVue } from '@/common/primary/button';

export default defineComponent({
  name: 'ProgramsPage',

  components: {
    ProgramsTableVue,
    FairplayerButtonVue,
    PageVue,
  },

  props: {
    clubSlug: {
      type: String,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
